import {
  FunctionComponent,
  useEffect,
  useRef, useState
} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import FormDataComponent from "../../components/Forms/FormData";
import CartCard from "../../components/cartCard/CartCard";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "./CheckoutDados.module.css";
import { Header } from "../../components/Header";
import ApiService from "../../service/ApiService";
import { Constants } from "../../utils/constants";
import General from "../../helpers/General";
import { useAppLocalStorage } from "../../hook/localStorage";
import { ecommerceEvents } from "../../utils/gtm";
import { initAffiliateScripts, trackInitCheckout, trackPaymentInfoAddition } from "../../utils/affiliateAnalytics";

const CheckoutDados: FunctionComponent = () => {
  const apiService = new ApiService();
  const navigate = useNavigate();
  const { 
    cart,
    clientAndAffiliate,
    addToCart,
    setPlanId,
    setClientAndAffiliate,
    setPlanName,
    purchaser,
    setPurchaserData,
    setTotalPrice,
    setCoupon,
    totalPrice,
    coupon,
    planName,
    planId,
    setAbandonedCartId
  } = useCheckout();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const cartCardRef = useRef(null);

  const width = window.innerWidth;

  const [isCartCardVisible, setIsCartCardVisible] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [errors, setErros] = useState({
    document_number_ErrorMsg: "",
    telephone_ErrorMsg: "",
    name_ErrorMsg: "",
    lastname_ErrorMsg: "",
    email_ErrorMsg: "",
    allfields_ErrorMsg: "",
  });
  const [checks, setChecks] = useState({
    policy: false,
    privacy: false,
  });
  const {slug, planSlug, productSlug} = params;

  const onSubmit = (data) => {
    return data
  };

  useEffect(() => {
    if (slug) {
      apiService.getAffiliateTagsBySlug(slug)
      .then((res: any) => {
        if (res) {
          const config: any = {};
          const tikTokAdsCode = res.tik_tok_ads_code?
            res.tik_tok_ads_code : "";
          const gtmCode = res.gtm_code? res.gtm_code : "";
          const googleAdsCode = res.google_ads_code? res.google_ads_code : "";
          const googleAdsConversionId = res.google_ads_conversion_id? res.google_ads_conversion_id : "";
          const googleAdsConversionLabel = res.google_ads_conversion_label? res.google_ads_conversion_label : "";
          const metaAdsCode = res.meta_ads_code? res.meta_ads_code : "";
          if (tikTokAdsCode) {
            config.tikTokAdsCode = tikTokAdsCode;
          }
  
          if (gtmCode) {
            config.gtmCode = gtmCode;
          }
  
          if (metaAdsCode) {
            config.metaAdsCode = metaAdsCode;
          }
  
          if (config) {
            initAffiliateScripts(config);
          }
        }
      }).catch((err: any) => {});
    }
    trackInitCheckout();
  }, [])

  const { app } = useAppLocalStorage();
  const couponURL = searchParams.get('cupom');
  useEffect(() => {
    const clientDomain = window.location.hostname;

    if (cart.length === 0 && params) {
      if (slug && !planSlug) navigate(`/${slug}`);
      else if(!planSlug && !productSlug) {
        navigate("/");
      } else {
        ApiService.getProductBySlug(
          planSlug as string,
          productSlug as string,
          slug || '',
          clientDomain,
          couponURL,
        ).then((response) => {
          if (!response) {
            navigate("/")
          } else {
            addToCart(response.productData);
            setPlanId(response.planId);
            setPlanName(response.planName);
            setClientAndAffiliate(response.clientAndAffiliate);

            let productQuantity = 0;
            let totalPriceCalc = 0;
            if (cart.length > 0) {
              cart.forEach(product => {
                productQuantity += product.quantity;
                totalPriceCalc += product.quantity * product.price;
              })
            } else {
              productQuantity += response.productData.quantity;
              totalPriceCalc += response.productData.price * response.productData.quantity;
            }

            cart.forEach(product => {
              productQuantity += product.quantity;
              totalPriceCalc += product.quantity * product.price;
            })

            apiService.validateCoupon(
              response.coupon?.name ? response.coupon.name : "__NO_COUPON__",
              productQuantity,
              totalPriceCalc,
              (clientAndAffiliate as any)?.affiliate_id 
              || response.clientAndAffiliate.affiliate_id || ""
            ).then((validateResponse) => {
              if (validateResponse.message === 'Coupon not found') {
                setTotalPrice(totalPriceCalc);
                setCoupon({ name: couponURL, message: '', found: null });
                return;
              }
              setCoupon({
                name: couponURL,
                found: validateResponse.coupon,
                message: validateResponse.message || '',
              });
              setTotalPrice(validateResponse.finalTotal);

              const customIdToast = "coupon-message";
              if (width < 800) {
                if (validateResponse.validatedCoupon) {
                  if(toast.isActive(customIdToast)) {
                    toast.update(customIdToast, {
                      render: validateResponse.message,
                      type: 'success',
                    })
                  } else {
                    toast.success(validateResponse.message, {
                      toastId: customIdToast
                    })
                  }
                } else if (validateResponse.message) {
                  if(toast.isActive(customIdToast)) {
                    toast.update(customIdToast, {
                      render: validateResponse.message,
                      type: 'error',
                    })
                  } else {
                    toast.error(validateResponse.message, {
                      toastId: customIdToast
                    })
                  }
                }
              }
            })
          }
        })
      }
    }
    const elemento = document.getElementById('seusDados');
    if (elemento) {
      elemento.scrollIntoView({ block: "start", behavior: "smooth"});
    }
  }, []);

  useEffect(() => {
      ecommerceEvents.beginCheckoutDados({
        currency: "BRL",
        value: totalPrice,
        coupon: coupon.name? coupon.name : "",
        afiliado: slug? slug : clientAndAffiliate.affiliate_id? clientAndAffiliate.affiliate_id : "",
        items: cart.map(item => ({
          item_id: item.id,
          item_name: item.name,
          price: item.price,
          quantity: item.quantity,
          promotion_id: planId,
          promotion_name: planName,
        })),
      });
  }, [cart, coupon.found, planName, totalPrice])


  const openCartCardModal = () => {
    setIsCartCardVisible(!isCartCardVisible);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartCardRef.current && !cartCardRef.current.contains(event.target)) {
        setIsCartCardVisible(false);
      }
    };

    if (isCartCardVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCartCardVisible]);

  const areFieldsFilled = () => {
    setPurchaserData(purchaser);
    const { document_number, telephone, name, lastname, email } = purchaser;
    return document_number && telephone && name && lastname && email;
  };

  const handleContinue = () => {
    if (areFieldsFilled() && !disabled) {
      localStorage.setItem(
        Constants.LOCALSTORAGE.purchaserData,
        JSON.stringify(purchaser)
      );

      const payload = {
        currency: "BRL",
        value: totalPrice,
        coupon: coupon.name ? coupon.name : "",
        email: purchaser.email,
        phone: purchaser.telephone.replace(/[()\-\s]/g, ''),
        first_name: purchaser.name,
        last_name: purchaser.lastname,
        afiliado: slug
          ? slug
          : clientAndAffiliate.affiliate_id
          ? clientAndAffiliate.affiliate_id
          : "",
        items: cart.map(item => ({
          item_id: item.id,
          item_name: item.name,
          price: item.price,
          quantity: item.quantity,
          promotion_id: planId,
          promotion_name: planName,
        })),
      };

      // Enviar para abandoned_sales
      apiService.createAbandonedSale({
        document_type: purchaser.document_number.includes('/') ? "CNPJ" : "CPF",
        document_number: purchaser.document_number,
        name: purchaser.name,
        last_name: purchaser.lastname,
        email: purchaser.email,
        telephone: purchaser.telephone.replace(/[()\-\s]/g, ''),
        products: cart.map(item => ({
          id: item.products_id,
          description: item.description,
          name: item.name,
          quantity: item.quantity,
          price: parseFloat(item.price),
          planName,
        })),
        planId: planId,
        couponId: coupon && coupon.found && coupon.found.id ? coupon.found.id : "",
        affiliateId: clientAndAffiliate.affiliate_id ? clientAndAffiliate.affiliate_id : ""
      }).then((res) => {
        setAbandonedCartId(res.id);
      })
      
      ecommerceEvents.signUp(payload);
      trackPaymentInfoAddition(payload);

      if (!params.slug && !params.planSlug) {
        navigate(`/checkout-entrega${couponURL ? `?cupom=${couponURL}` : ''}`);
      } else if (params.slug && !params.planSlug) {
        navigate(`/checkout-entrega/${params.slug}${couponURL ? `?cupom=${couponURL}` : ''}`)
      } else if (params.slug && params.productSlug) {
        navigate(`/checkout-entrega/${
            params.slug
          }/${params.planSlug}/${params.productSlug}${couponURL ? `?cupom=${couponURL}` : ''}`)
      } else if (params.planSlug && params.productSlug) {
        navigate(`/checkout-entrega/${params.planSlug}/${params.productSlug}${couponURL ? `?cupom=${couponURL}` : ''}`)
      }
    } else {
      if (!Object.values(errors).some((x) => x !== "")) {
        if (Object.values(checks).some((x) => !x)) {
          setErros({
            ...errors,
            allfields_ErrorMsg:
              "Por favor, aceite os Termos de Uso e a Política de Privacidade.",
          });
        } else {
          setErros({
            ...errors,
            allfields_ErrorMsg: "Preencha todos os dados",
          });
        }
      }
    }
  };

  const changeChecks = (
    value: { policy: boolean, privacy: boolean }
  ) => {
    setChecks(value)
  }

  const changeErrors = (value: {
    document_number_ErrorMsg: string,
    telephone_ErrorMsg: string,
    name_ErrorMsg: string,
    lastname_ErrorMsg: string,
    email_ErrorMsg: string,
    allfields_ErrorMsg: string,
  }) => {
    setErros(value)
  }

  const changeDisabled = (value:boolean) => {
    setDisabled(value)
  }

  return (
    <div className={styles.checkoutDados}>
      {/* <div className={styles.header}> */}
        <Header path="/" />
      {/* </div> */}
      <div className={styles.conteudo}>
        <div className={styles.colunaDireita}>
          <div className={styles.titulo}>
            <div id='seusDados'className={styles.seusDados}>Seus dados</div>
            <div className={styles.div}>{`>`}</div>
            <div className={styles.div}>Endereço de entrega</div>
            <div className={styles.div}>{`>`}</div>
            <div className={styles.div}>Pagamento</div>
          </div>
          <FormDataComponent
            onSubmit={onSubmit}
            setChecks={changeChecks}
            checks={checks}
            setErros={changeErrors}
            errors={errors}
            disabled={disabled}
            setDisabled={changeDisabled}
            handleContinue={handleContinue}
          />
        </div>
        {width > 800 ? (
          <div className={styles.colunaEsqueda}>
            <CartCard showProducts={true} />
          </div>
        ) : (
          <>
            <div className={styles.cartIconBox} onClick={openCartCardModal}>
              <svg
                className={styles.cartIcon}
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="27"
                viewBox="0 0 576 512"
              >
                <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
              </svg>
            </div>
            {/* <div className={styles.botao4} onClick={openCartCardModal} >
              <div className={styles.cta10}  >
                <img className={styles.icones132} alt="" src="/icones4.svs" />
                <div className={styles.continuarCompra24}>Continuar para entrega</div>
                <img className={styles.icones133} alt="" src="/icones5.svg" />
              </div>
            </div> */}
          </>
        )}

        {!isCartCardVisible && width < 800 && (
          <div className={disabled ? styles.cta : styles.filledCart} 
            onClick={handleContinue}>
            <div className={styles.continuarCompra24}>
              <button
                className={styles.btnContinuarCompra}
                disabled={disabled}
                onClick={handleContinue}
              >
                Continuar para entrega
              </button>
            </div>
            <img className={styles.icones133} alt="" src="/icones5.svg" />
          </div>
        )}

        {isCartCardVisible && width < 800 && (
         <div className={`${styles.cartCardModal} ${isCartCardVisible ? 
         styles.showModal : ''}`}>
            <div className={styles.cartCardContent } ref={cartCardRef}>
            <CartCard showProducts={true} />
            <div
              className={styles.cta1}
              onClick={openCartCardModal}
              style={{borderRadius: 0}}
            >
              <div className={styles.yelly}>Voltar</div>
              {/* <img className={styles.icones18} alt="" src="/icones4.svg" /> */}
            </div>
          </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutDados;
